import React, { useEffect, useState } from 'react';
import styles from './styles.module.sass';
import { useAppDispatch, useAppSelector } from 'hooks';
import { requestsActions } from 'utils/store/slice';
import { RequestStatus } from 'types/enums';
import classNames from 'classnames';

export const RequestForm = () => {
  const dispatch = useAppDispatch();
  const analyzedRequest = useAppSelector((state) => state.requests.analyzedRequest);
  const [areaValue, setAreaValue] = useState('');

  useEffect(() => {
    if (analyzedRequest?.reason) {
      setAreaValue(analyzedRequest.reason);
    }
  }, [analyzedRequest]);

  const handleAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAreaValue(e.target.value);
  };

  const handleConfirmRequest = () => {
    const shouldDropReason = analyzedRequest.status === RequestStatus.REJECTED && areaValue === analyzedRequest?.reason;
    const reason = shouldDropReason ? '' : areaValue;
    dispatch(
      requestsActions.updateRequest({
        ...analyzedRequest,
        reason,
        status: RequestStatus.APPROVED,
      }),
    );
    setAreaValue('');
  };

  const handleDeclareRequest = () => {
    dispatch(requestsActions.updateRequest({ ...analyzedRequest, reason: areaValue, status: RequestStatus.REJECTED }));
    setAreaValue('');
  };

  return (
    <div className={styles.requestForm}>
      <textarea
        value={areaValue}
        onChange={handleAreaChange}
        placeholder='If request is declined, please enter here why...'
        className={styles.textarea}
      />
      <div className={styles.buttonContainer}>
        <button className={classNames([styles.button, styles.confirm])} onClick={handleConfirmRequest}>
          Confirm Request
        </button>
        <button
          className={classNames([styles.button, styles.declare])}
          onClick={handleDeclareRequest}
          disabled={!areaValue.trim()}
        >
          Decline Request
        </button>
      </div>
    </div>
  );
};
